export default __webpack_public_path__ + "media/images/website-c05a157782a58eedba3c3726afca2aed.svg";